export default __webpack_public_path__ + "static/media/bajajfinserv.f2121739.png";